import { useMemo } from 'react'
import { useAppStore } from '@/store/appStore'
import { mapContextProducts } from './api'

export function useProductos() {
  const { org, products } = useAppStore()

  const mapped = useMemo(() => mapContextProducts(products.items), [products.items])

  return {
    data: {
      orgName: org.current?.orgName ?? null,
      orgPartyPublicId: org.current?.orgPartyPublicId ?? null,
      products: mapped,
    },
    loading: false,
    error: null,
    refetch: () => Promise.resolve(),
  }
}
